import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { lastValueFrom, take } from 'rxjs';
import { FileService } from '../../shared/services/file.service';
import { LoadingService } from './../../shared/services/loading.service';

@Component({
  selector: 'app-upload-documents',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './upload-documents.component.html',
  styleUrls: ['./upload-documents.component.scss'],
  providers: [FileService],
})
export class UploadDocumentsComponent {
  private readonly fileService = inject(FileService);
  private readonly loadingService = inject(LoadingService);
  file: File | null = null;

  async onFileSelected(event: any): Promise<void> {
    this.file = event.target.files[0];

    if (!this.file) return;

    this.loadingService.showLoading();

    const res = await lastValueFrom(
      this.fileService.uploadImage(this.file).pipe(take(1))
    );

    if (res) {
      this.loadingService.closeLoading();
    }
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    if (event.dataTransfer?.files) {
      this.file = event.dataTransfer.files[0];
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }
}
